import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const wrapTextWithSpan = target => {
  const nodes = [...target.childNodes];
  let returnText = '';

  for (const node of nodes) {
    if (node.nodeType == 3) {
      const text = node.textContent.replace(/\r?\n/g, '');
      const splitText = text.split('');
      for (const char of splitText) {
        returnText += `<span>${char}</span>`;
      }
    } else {
      returnText += node.outerHTML;
    }
  }

  returnText = returnText.replace(/ /g, '&nbsp;');

  return returnText;
};
const titleAnimation = () => {
  const titleElements = document.querySelectorAll('.js-title-animation');

  if (titleElements.length === 0) {
    return;
  }


  titleElements.forEach(title => {
    title.innerHTML = wrapTextWithSpan(title);
    title.spans = title.querySelectorAll('span');

    gsap.set(title.spans, {
      display: 'inline-block',
      opacity: 0,
      y: '120%'
    });

    const subTitle = title.nextElementSibling;

    if (subTitle) {
      subTitle.innerHTML = wrapTextWithSpan(subTitle);
      subTitle.spans = subTitle.querySelectorAll('span');
      gsap.set(subTitle.spans, {
        display: 'inline-block',
        opacity: 0,
        y: '120%'
      });

    }

    gsap.set([title, subTitle], {
      opacity: 1,
      scrollTrigger: {
        trigger: title,
        start: 'top bottom'
      },
    });

    gsap.to(title.spans, {
      ease: "power2.inOut",
      duration: 1,
      opacity: 1,
      y: '0',
      stagger: 0.02,
      scrollTrigger: {
        trigger: title,
        start: 'top 90%'
      },
      onStart() {
        if (subTitle) {
          gsap.to(subTitle.spans, {
            delay: .5,
            stagger: 0.02,
            ease: "power2.inOut",
            opacity: 1,
            y: '0',
          });
        }
      }
    });
  });
};

const init = () => {
  // hoverButtonAnimation();
  titleAnimation();
};

export default init;
